<template>
    <div
        :class="{ 'stat-link': hasLink }"
        :style="borderColorStyle"
        class="flex items-center align-middle"
        @click="followLink"
    >
        <template v-if="alignRight">
            <div class="flex flex-grow justify-between items-center pl-4 text-right">
                <div class="w-full">
                    <h4 class="font-bold">{{ value }}</h4>
                    <span>{{ name }}</span>
                </div>
                <vx-basic-icon
                    v-if="!hideIcon"
                    class="icon-avatar ml-4"
                    rounded
                    size="7"
                    :icon="icon"
                    :color="color"
                />
            </div>
        </template>
        <template v-else>
            <vx-basic-icon class="icon-avatar mr-4" rounded size="7" :icon="icon" :color="color" />
            <div class="flex flex-grow justify-between items-center pr-4">
                <div class="w-full">
                    <h4 class="font-bold">{{ value }}</h4>
                    <span>{{ name }}</span>
                </div>
                <vx-basic-icon
                    v-if="!hideIcon"
                    class="arrow-link justify-self-end"
                    icon="ChevronRightIcon"
                />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'vx-statistic-badge',
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        color: {
            type: String,
            default: 'primary'
        },
        icon: {
            type: String
        },
        link: {
            type: [String, Object]
        },
        beforeLink: {
            type: Function
        },
        alignRight: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    computed: {
        hasLink() {
            return !!this.link
        },
        hideIcon() {
            return !this.icon
        },
        borderColorStyle() {
            if (!this.hasLink) {
                return ''
            }

            const boxShadow = 'box-shadow: 0px 0px 10px 1px'

            if (this.color.startsWith('#')) {
                // 70% alpha
                var hexWithAlpha = this.color.substring(0, 7) + 'B2'
                return `${boxShadow} ${hexWithAlpha};`
            } else if (this.color.startsWith('rgb')) {
                var rgbSection = this.color.match(/rgba?\((\d+\s*,\s*\d+\s*,\s*\d+).+/)[1]
                return `${boxShadow} rgba(${rgbSection}, 0.7);`
            }

            return `${boxShadow} rgba(var(--vs-${this.color}), 0.7);`
        }
    },
    methods: {
        followLink(e) {
            this.$emit('click', e)
            if (this.hasLink) {
                if (this.beforeLink) {
                    this.beforeLink()
                }
                this.$router.push(this.link)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.stat-link {
    &:hover {
        .arrow-link {
            transform: translateX(0);
            display: flex;
            opacity: 1;
        }

        cursor: pointer;
    }

    &:not(:hover) {
        box-shadow: none !important;
    }
    border-radius: 24px;
    overflow: hidden;
    transition: all 0.2s ease;
}

.arrow-link {
    transform: translateX(-15px);
    transition: all 0.25s ease;
    opacity: 0;
}

.icon-avatar {
    transition: all 0.2s ease;
    height: 48px;
    width: 48px;
}
</style>
